import React, { createContext, useContext, useEffect, useState } from 'react'
import LayoutSidebar from './sidebar'
import {Avatar, Button, ConfigProvider, Layout, notification, Space} from 'antd'
import LayoutHeader from './header'
import LayoutContent from './content'
import { useLocation, useNavigate } from 'react-router-dom'
import { Type } from './constant/Constant'
import {
    firebaseConfig,
    serverKey
} from '../common/config-variable/notification'
import { getMe } from '../api/system/admin/user-account'
import { postNotificationPush } from '../api/common/layout/notification-push/api'
import { getMessaging, getToken as getDeviceToken } from 'firebase/messaging'
import { initializeApp } from 'firebase/app'
import { initTheme } from './header/components/theme/data/initTheme'
import { useDispatch } from 'react-redux'
import { onChangeAbility } from '../redux/actions/ability/Action'
import ability, { ActionKeys, SubjectName } from '../custom/permission/Ability'
import { AbilityContext, AbilityUtil } from '../custom/permission/Can'
import { useEffectOnce } from 'react-use'
import { defaultSiderData } from './constant/Data'
import { getWorkspaceKeys } from '../api/permission/action'
import ErrorPaymentStatus from '../components/payment/error/ErrorPaymentStatus'
import { getDoConfigObjects } from '../api/workplace/process/work-process/process-config'
import {BASE_DOMAIN, BASE_PATH} from '../custom/axios/config/Url'
import { MainAppContextProvider } from '../hooks/useMainAppContext'
import { useLazyQuery } from '@apollo/client'
import { QUERY_GET_USER_PROFILE_GQL } from '../api/common/profile/profileGql'
import {getUserPreference, updateUserPreference} from "../api/login/api";
import Cookies from "js-cookie";
import i18n, {t} from "i18next";
import {TranslationOutlined} from "@ant-design/icons";
import i18next from "i18next";

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

const MainLayoutContext = createContext({})

export const useMainLayoutContext = () => useContext(MainLayoutContext)

function MainLayoutV2() {
    const [theme, setTheme] = useState({})

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [type, setType] = useState(Type.main)
    const [siderData, setSiderData] = useState([])
    const [workspaceKeys, setWorkspaceKeys] = useState(null)
    const [doConfigObject, setDoConfigObject] = useState([])
    const [loading, setLoading] = useState(true)
    const deviceLang = localStorage.getItem('lang') || 'vi'
    const officeLang = Cookies.get("language");
    const [getProfile, {data: profileData}] = useLazyQuery(QUERY_GET_USER_PROFILE_GQL, {
        fetchPolicy: 'network-only'
    });

    useEffect(() => {
        getProfile().then(r => r)
    }, []);

    useEffect(() => {
        if (profileData) {
            localStorage.setItem('userProfile', JSON.stringify(profileData?.userProfile))
        }
    }, [profileData]);

    useEffect(() => {
        getDoConfigObjects().then((r) => {
            setDoConfigObject(r?.doConfigObjectItems)
        })
    }, [])

    useEffect(() => {
        setTheme(JSON.parse(localStorage.getItem('theme')))
    }, [localStorage.getItem('theme')])

    useEffectOnce(() => {
        if (Notification.permission === 'granted') {
            getNotificationRequest()
        } else if (Notification.permission !== 'denied') {
            const notificationRequest = setTimeout(() => {
                notification.open({
                    message: (
                        <div className={'flex justify-center items-center'}>
                            <Avatar
                                size={60}
                                src={
                                    BASE_PATH + '/static-medias/logo/doTnp.png'
                                }
                            />
                        </div>
                    ),
                    description:
                        t("dashboard.notification.message"),
                    key: 'notificationRequest',
                    duration: null,
                    btn: (
                        <div className={'notification-request-permission'}>
                            <Button
                                className={'mr-3'}
                                onClick={handleDeniedRequestNotification}>
                                {t("dashboard.notification.button.no")}
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleAcceptRequestNotification}
                            >
                                {t("dashboard.notification.button.yes")}
                            </Button>
                        </div>
                    ),
                    closeIcon: false,
                    placement: 'topLeft'
                })
            }, 2000)

            return () => {
                clearTimeout(notificationRequest)
            }
        }
    })

    const getNotificationRequest = () => {
        Notification.requestPermission()
            .then((permission) => {
                if (permission === 'granted') {
                    getDeviceToken(messaging, { vapidKey: serverKey })
                        .then((currentToken) => {
                            localStorage.setItem('deviceToken', currentToken)
                            const notificationPush = {
                                accountId: getMe()?.accountId,
                                deviceToken: currentToken,
                                type: 'dotp'
                            }
                            postNotificationPush(notificationPush)
                                .then()
                                .catch(() => {})
                        })
                        .catch(() => {
                            console.log('Dont have token')
                        })
                } else {
                    console.log('Dont have permission')
                }
            })
            .catch(() => {})
    }

    const handleAcceptRequestNotification = () => {
        getNotificationRequest()

        notification.destroy('notificationRequest')
    }

    const handleDeniedRequestNotification = () => {
        notification.destroy('notificationRequest')
    }

    useEffect(() => {
        let type = location.pathname.includes('/setting')
            ? Type.setting
            : Type.main
        setSiderData(defaultSiderData(t)[type])

        setType(type)
    }, [location.pathname, i18next.language])


    useEffect(() => {
        const debounce = setTimeout(() => {
            if (location.pathname === '/') {
                let forbiddenTimeKeeping = !AbilityUtil.allow(
                    ActionKeys.READ,
                    SubjectName.timeKeeping,
                    {}
                )
                let forbiddenSalary = !AbilityUtil.allow(
                    ActionKeys.READ,
                    SubjectName.salaryTable,
                    {}
                )
                if (!forbiddenTimeKeeping) {
                    navigate('/hrm/timekeeping/time-sheet/timesheet')
                } else if (!forbiddenSalary) {
                    navigate('/hrm/timekeeping/wage/table')
                }
            }
        }, 200)
        return () => {
            clearTimeout(debounce)
        }
    }, [location.pathname])

    useEffect(() => {
        setLoading(true)
        getWorkspaceKeys(getMe()?.accountId, 'tnp')
            .then((response) => {
                if (!response?.enable) {
                    navigate('/403')
                } else {
                    setWorkspaceKeys(response)
                    dispatch(onChangeAbility(ability(response)))
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])
    const handleCancel = (userLang, deviceLang) => {
        handleUpdateLange(userLang)
        notification.destroy()
    }
    const handleUpdateLange = (userLang) => {

        if (userLang) {
            i18n.changeLanguage(userLang).then(() => {
                localStorage.setItem('lang', userLang)
                Cookies.set("language", userLang, {expires: 30, domain: BASE_DOMAIN});
            })
        }
    }
    const getLanguage = (lang) => {
        return t(`dashboard.changeLanguage.${lang}`)
    }
    const openUpDateNotification = (newLang) => {
        notification.open({
            message: t('dashboard.changeLanguage.title'),
            description: (
                <span style={{ color: '#172b4d' }}>
                    {t('dashboard.changeLanguage.updateLanguage', {
                        updateLang: getLanguage(newLang)
                    })}
                </span>
            ),
            duration: 3,
            icon: <TranslationOutlined />,
            style: {
                backgroundColor: '#e2eefb',
                padding: '14px 18px',
                borderRadius: '8px',
                width: 370
            }
        })
    }
    const handleChangeLanguage = (userRef, newLang) => {
        notification.destroy()
        const newPreference = JSON.stringify({
            ...userRef,
            lang: newLang
        })
        setTimeout(() => {
            updateUserPreference({
                preference: newPreference
            }).then(() => {
                handleUpdateLange(newLang)
            })
        }, 0)
    }
    const openNotification = (newLang, userRef, deviceLang) => {
        const key = `open${Date.now()}`
        const btn = (
            <Space>
                <Button
                    type="link"
                    size="small"
                    onClick={() => handleChangeLanguage(userRef, newLang)}
                >
                    {t('dashboard.changeLanguage.keep', {
                        deviceLang: getLanguage(newLang)
                    })}
                </Button>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleCancel(userRef?.lang, deviceLang)}
                >
                    {t('dashboard.changeLanguage.use', {
                        userLang: getLanguage(userRef?.lang)
                    })}
                </Button>
            </Space>
        )
        notification.open({
            message: t('dashboard.changeLanguage.title'),
            description: t('dashboard.changeLanguage.description', {
                deviceLang: getLanguage(newLang),
                userLang: getLanguage(userRef?.lang)
            }),
            btn,
            key,
            duration: 0,
            icon: <TranslationOutlined/>,
            onClose: () => notification.destroy()
        })
    }
    const loadUserPreference = () => {
        getUserPreference().then((r) => {
            const userRef = JSON.parse(r?.preference || '{}')
            if (userRef?.lang !== deviceLang) {
                handleUpdateLange(userRef?.lang)
                openUpDateNotification(userRef?.lang)
            }
            else if (officeLang && officeLang !== deviceLang) {
                i18n.changeLanguage(officeLang).then(() => {
                    localStorage.setItem('lang', officeLang)
                })
                const delay = setTimeout(() => {
                    openNotification(officeLang, userRef, deviceLang)
                }, 2000);
                return () => clearTimeout(delay);
            }
        })
    }

    useEffect(() => {
        loadUserPreference()
    }, [])
    const layoutError = () => {
        return getMe()?.paymentStatus ? (
            <MainAppContextProvider>
                <Layout
                    style={{
                        height: '100vh',
                        width: '100vw',
                        maxHeight: '100vh',
                        maxWidth: '100vw'
                    }}
                >
                    <LayoutSidebar />
                    <Layout>
                        <LayoutHeader />
                        <LayoutContent />
                    </Layout>
                </Layout>
            </MainAppContextProvider>
        ) : (
            <ErrorPaymentStatus />
        )
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    ...theme,
                    ...initTheme,
                    fontSize: 14,
                    wireframe: false,
                    colorPrimary: '#1d9336',
                    colorPrimaryText: '#344054',
                    fontFamily: "'Open Sans', sans-serif"
                }
            }}
        >
            <MainLayoutContext.Provider
                value={{
                    type,
                    siderData,
                    workspaceKeys,
                    doConfigObject
                }}
            >
                <AbilityContext.Provider value={ability(workspaceKeys)}>
                    {!loading ? layoutError() : <div></div>}
                </AbilityContext.Provider>
            </MainLayoutContext.Provider>
        </ConfigProvider>
    )
}

export default MainLayoutV2
